// Dark mode logos - local assets
import SGXFirstDark from '@g17eco/images/dark-mode/sgx-first-logo-dark.png';
import AssuranceTrackerDark from '@g17eco/images/dark-mode/Assurance_Tracker_dark.svg';
import CityTrackerDark from '@g17eco/images/dark-mode/City_Tracker_dark.svg';
import CompanyTrackerDark from '@g17eco/images/dark-mode/Company_Tracker_dark.svg';
import EmissionsTrackerDark from '@g17eco/images/dark-mode/Emissions_Tracker_dark.svg';
import MaterialityTrackerDark from '@g17eco/images/dark-mode/Materiality_Tracker_dark.svg';
import NationTrackerDark from '@g17eco/images/dark-mode/Nation_Tracker_dark.svg';
import PortfolioTrackerDark from '@g17eco/images/dark-mode/Portfolio_Tracker_dark.svg';
import ProjectTrackerDark from '@g17eco/images/dark-mode/Project_Tracker_dark.svg';
import SDGapDark from '@g17eco/images/dark-mode/SDGap_dark.svg';
import WorldTrackerDark from '@g17eco/images/dark-mode/World_Tracker_dark.svg';

// Light mode logos - local assets
import SGXFirst from '@g17eco/images/sgx-first-logo.png';
import AssuranceTrackerLogo from '@g17eco/images/apps/Assurance_Tracker_logo.svg';
import CityTrackerLogo from '@g17eco/images/apps/City_Tracker_logo.svg';
import CompanyTrackerLogo from '@g17eco/images/apps/Company_Tracker_logo.svg';
import EmissionsTrackerLogo from '@g17eco/images/apps/Emissions_Tracker_logo.svg';
import MaterialityTrackerLogo from '@g17eco/images/apps/Materiality_Tracker_logo.svg';
import NationTrackerLogo from '@g17eco/images/apps/Nation_Tracker_logo.svg';
import PortfolioTrackerLogo from '@g17eco/images/apps/Portfolio_Tracker_logo.svg';
import ProjectTrackerLogo from '@g17eco/images/apps/Project_Tracker_logo.svg';
import SDGapLogo from '@g17eco/images/apps/SDGAP_logo.svg';
import WorldTrackerLogo from '@g17eco/images/apps/World_Tracker_logo.svg';
import config from '../../../config';

// CDN URLs
const CDN_BASE = config.media.cdnUrl;

// CDN app logos (light mode - apps/default/)
const CdnCompanyTrackerLogo = `${CDN_BASE}/apps/default/Company_Tracker_logo.svg`;
const CdnMaterialityAssessmentLogo = `${CDN_BASE}/apps/default/Materiality_Assessment_logo.svg`;
const CdnMaterialityTrackerLogo = `${CDN_BASE}/apps/default/Materiality_Tracker_logo.svg`;
const CdnPortfolioTrackerLogo = `${CDN_BASE}/apps/default/Portfolio_Tracker_logo.svg`;
const CdnSDGapLogo = `${CDN_BASE}/apps/default/SDGAP_logo.svg`;
const CdnWorldTrackerLogo = `${CDN_BASE}/apps/default/World_tracker_logo.svg`;

// CDN app logos (light mode - carbon-calculators/)
const CdnCarbonEmissionsTrackerLogo = `${CDN_BASE}/carbon-calculators/Emissions_Tracker_logo.svg`;

// CDN app logos (dark mode - apps/dark/)
const CdnCompanyTrackerDark = `${CDN_BASE}/apps/dark/Company_Tracker_dark.svg`;
const CdnMaterialityTrackerDark = `${CDN_BASE}/apps/dark/Materiality_Tracker_dark.svg`;
const CdnPortfolioTrackerDark = `${CDN_BASE}/apps/dark/Portfolio_Tracker_dark.svg`;
const CdnSDGapDark = `${CDN_BASE}/apps/dark/SDGap_dark.svg`;
const CdnWorldTrackerDark = `${CDN_BASE}/apps/dark/World_Tracker_dark.svg`;
const CdnEmissionsTrackerDark = `${CDN_BASE}/apps/dark/Emissions_Tracker_dark.svg`;

// Partner/consultancy logos (light mode)
const CavendishLogo = `${CDN_BASE}/images/home/cavendish.png`;
const JordiskLogo = `${CDN_BASE}/images/home/jordisk_consulting.png`;
const NzcgLogo = `${CDN_BASE}/images/home/nzcg-w.png`;
const OneClickLogo = `${CDN_BASE}/images/home/oneclick.png`;
const WwtLogo = `${CDN_BASE}/images/home/worldwidetechnology.png`;
const ToliLogo = `${CDN_BASE}/apps/toli/toli-logo.svg`;

// Partner/consultancy logos (dark mode)
const CavendishDark = `${CDN_BASE}/images/home/cavendish-dark.png`;
const JordiskDark = `${CDN_BASE}/images/home/jordisk-dark.png`;
const NzcgDark = `${CDN_BASE}/images/home/nzcg-w-dark.png`;
const OneClickDark = `${CDN_BASE}/images/home/oneclick-dark.png`;
const WwtDark = `${CDN_BASE}/images/home/wwt-dark.png`;
const ToliLogoDark = `${CDN_BASE}/apps/toli/toli-logo-dark.svg`;

const darkLogoMap: Record<string, string> = {
  // Local assets
  [SGXFirst]: SGXFirstDark,
  [AssuranceTrackerLogo]: AssuranceTrackerDark,
  [CityTrackerLogo]: CityTrackerDark,
  [CompanyTrackerLogo]: CompanyTrackerDark,
  [EmissionsTrackerLogo]: EmissionsTrackerDark,
  [MaterialityTrackerLogo]: MaterialityTrackerDark,
  [NationTrackerLogo]: NationTrackerDark,
  [PortfolioTrackerLogo]: PortfolioTrackerDark,
  [ProjectTrackerLogo]: ProjectTrackerDark,
  [SDGapLogo]: SDGapDark,
  [WorldTrackerLogo]: WorldTrackerDark,
  // CDN app logos (apps/default/)
  [CdnCompanyTrackerLogo]: CdnCompanyTrackerDark,
  [CdnMaterialityAssessmentLogo]: CdnMaterialityTrackerDark,
  [CdnMaterialityTrackerLogo]: CdnMaterialityTrackerDark,
  [CdnPortfolioTrackerLogo]: CdnPortfolioTrackerDark,
  [CdnSDGapLogo]: CdnSDGapDark,
  [CdnWorldTrackerLogo]: CdnWorldTrackerDark,
  // CDN app logos (carbon-calculators/)
  [CdnCarbonEmissionsTrackerLogo]: CdnEmissionsTrackerDark,
  // Partner/consultancy logos
  [CavendishLogo]: CavendishDark,
  [JordiskLogo]: JordiskDark,
  [NzcgLogo]: NzcgDark,
  [OneClickLogo]: OneClickDark,
  [WwtLogo]: WwtDark,
  [ToliLogo]: ToliLogoDark,
};

export const getThemedLogoSrc = (lightSrc: string | undefined, isDarkMode: boolean): string | undefined => {
  if (!lightSrc || !isDarkMode) {
    return lightSrc;
  }
  return darkLogoMap[lightSrc] ?? lightSrc;
};
